import { useEffect, useMemo, useState } from "react";
import { shuffleArray } from "./general";

export const getQuestionsByPostId = async (postId) => {
  if (!postId) {
    return;
  }

  const response = await fetch(
    `http://edus.ibrbs.pl/wp-json/wp/v2/gry/${postId}`
  );

  if (response.ok) {
    const data = await response.json();
    return data?.ACF?.test_questions || [];
  }
  throw Error("Brak danych");
};

export const useQuestionsGenerator = (postId) => {
  const [questions, setQuestions] = useState([]);
  const NUMBER_OF_QUESTIONS = Math.min(questions.length, 10);

  useEffect(() => {
    if (typeof postId === "number" || typeof postId === "string") {
      getQuestionsByPostId(postId).then(shuffleArray).then(setQuestions);
    }
  }, [postId]);

  const generator = useMemo(() => {
    function* questionsGenerator() {
      for (let i = 0; i < NUMBER_OF_QUESTIONS; i++) {
        yield { ...questions[i], index: i + 1 };
      }
    }
    return questionsGenerator();
  }, [questions, NUMBER_OF_QUESTIONS]);

  return [questions.length > 0 ? generator : null, NUMBER_OF_QUESTIONS];
};
